<template>
    <div :style="showing ? 'display:grid; grid-template-columns: 1fr 1fr; grid-gap: 5px; margin-right:11px' : 'display:grid; grid-template-columns: 1fr; margin-right:11px'">
        <input @input="emitSearch" type="search" :placeholder="labelSearch" class="form-control">
        <slot name="button"></slot>
    </div>
</template>

<script>
    import  debounce  from 'lodash/debounce'
    export default {
        name: "withSearch",
        props:{
            showing:{
                type: Boolean,
                default: () => false
            },
            labelSearch: {
                type: String,
                default: () => ''
            }
        },
        data: () => ({
            search: '',
        }),

        watch:{
            /*
            'search': function (val) {
                this.$emit('makeSearch',val)
            }*/
        },
        methods:{
            emitSearch: debounce(function (e) {
               this.$emit('makeSearch', e.target.value)
            }, 500),
        }
    }
</script>

<style scoped>

</style>
